<template>
    <div id="huanbao">
        <slider :platInfo = platInfo></slider>
    </div>
</template>

<script>
    import slider from '../../components/slider.vue'
    export default {
        name: "huanbao",
        components:{slider},
        data() {
            return {
                swiper: null,
                platInfo:huanbaoInfo,
            }
        },
        methods: {},
        mounted() {

        }
    }
</script>

<style lang="css" scoped>
    #huanbao{
        width: 100%;
        height: 100%;
        overflow: auto;
        display: flex;
        flex-direction: row;
        background: linear-gradient(to right,#C1F2F9,#fff,#C1F2F9);;
    }
</style>



// WEBPACK FOOTER //
// src/views/huanbao/huanbao.vue